import { render } from "./ComingSoonPopup.vue?vue&type=template&id=dabcba6e&scoped=true"
import script from "./ComingSoonPopup.vue?vue&type=script&lang=js"
export * from "./ComingSoonPopup.vue?vue&type=script&lang=js"

import "./ComingSoonPopup.vue?vue&type=style&index=0&id=dabcba6e&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabcba6e"]])

export default __exports__